import React from 'react';
import AddAlert from '@material-ui/icons/AddAlert';
import IconButton from '@material-ui/core/IconButton';
import TableType2 from 'src/components/sharedComponents/Tablas/TableType2/TableType2';
import Snackbar from 'src/components/sharedComponents/Snackbar/Snackbar';
import { permitsList } from 'src/constants/permits';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import AlertDialogPrices from 'src/components/master/AlertDialogPrices';

const PricesPage = (props) => {
  const {
    update,
    precios = [],
    onUpdate,
    loading,
    permisos,
    scraping,
    onChangeState,
    onSaveScraping,
    onNotification,
    handleSaveScraping,
    handlePriceSelected,
  } = props;

  const columns = [
    {
      field: 'Scraping',
      title: 'Scraping',
      render: (rowData) => (
        <IconButton
          onClick={() => handlePriceSelected(rowData)}
          aria-label=""
          style={{
            backgroundColor: rowData.estadoScraping ? 'green' : 'grey',
            color:
              rowData.scraping === 0 && rowData.estadoScraping === 0
                ? 'black'
                : rowData.scraping === 1 && rowData.estadoScraping === 0
                  ? 'red'
                  : rowData.scraping === undefined
                  && rowData.estadoScraping === undefined
                    ? 'blue'
                    : 'white',
          }}
        >
          <AddAlert />
        </IconButton>
      ),
    },
    { title: 'Estado', field: 'error', editable: 'never' },
    { title: 'Unidades', field: 'unidades', editable: 'never' },
    { title: 'Empresa', field: 'empresa', editable: 'never' },
    { title: 'Cod_Ensambl', field: 'cod_assambler', editable: 'never' },
    { title: 'Marca', field: 'marca', editable: 'never' },
    { title: 'Linea', field: 'linea', editable: 'never' },
    { title: 'Carroceria', field: 'carroceria', editable: 'never' },
    { title: 'Combustible', field: 'combustible', editable: 'never' },
    { title: 'Precio', field: 'precio', type: 'numeric' },
  ];

  return (
    <>
      <AlertDialogPrices
        scraping={scraping}
        handleSaveScraping={handleSaveScraping}
        onSaveScraping={onSaveScraping}
      />
      <CardTitle title="Tabla de precios" />
      <Snackbar
        place="tr" // Depende la dirección en la que se va a mostrar
        color="warning"
        icon={AddAlert}
        message="Actualización en progreso...."
        open={update} // true o false
      />
      <TableType2
        title
        showButton
        isSelection
        hiddenDelete
        columns={columns}
        loading={loading}
        dataTable={precios}
        onUpdate={onUpdate}
        onSelectRow={onChangeState}
        onNotification={onNotification}
        idPermiso={permitsList.SEGMENTACION_MAESTROS_PRECIOS}
        minValue={permisos[permitsList.SEGMENTACION_MAESTROS_PRECIOS]}
      />
    </>
  );
};

export default PricesPage;
